import { P, S, T } from '../../../styles/tokens';
import { Check, Lock } from './Icons';

export type SubstepState = 'done' | 'active' | 'pending';

export interface SubstepCardProps {
  index: number;
  parentIndex: number;
  label: string;
  state: SubstepState;
  /** Description text shown below the label */
  desc?: string;
  onClick?: () => void;
}

// inactive track colour — mirrors StepStrip and prototype
const TRACK_INACTIVE = '#E8E3D4';

function Badge({
  index, parentIndex, state,
}: Pick<SubstepCardProps, 'index' | 'parentIndex' | 'state'>) {
  const isDone   = state === 'done';
  const isActive = state === 'active';
  const bg    = isDone ? P.success : isActive ? P.terracotta : TRACK_INACTIVE;
  const color = isDone || isActive ? '#fff' : P.muted;
  return (
    <div
      data-testid="substep-badge"
      style={{
        width: 34, height: 34, borderRadius: 17,
        background: bg, color,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        flexShrink: 0, font: T.caption, fontWeight: 700,
      }}
    >
      {isDone
        ? <span style={{ color: '#fff', display: 'flex' }}><Check size={16} /></span>
        : isActive
          ? <span>{parentIndex}.{index}</span>
          : <span style={{ display: 'flex', opacity: 0.7 }}><Lock size={14} /></span>
      }
    </div>
  );
}

export function SubstepCard({
  index, parentIndex, label, desc, state, onClick,
}: SubstepCardProps) {
  const isActive  = state === 'active';
  const isPending = state === 'pending';
  const isDone    = state === 'done';

  return (
    <button
      data-testid="substep-card"
      data-state={state}
      onClick={onClick}
      disabled={isPending}
      style={{
        width: '100%', display: 'flex', alignItems: 'center', gap: 12,
        padding: 12,
        background: '#fff',
        border: `${isActive ? 2 : 1}px solid ${isActive ? P.terracotta : P.line}`,
        borderRadius: 14,
        opacity: isPending ? 0.55 : 1,
        cursor: isPending ? 'default' : 'pointer',
        textAlign: 'left',
        transition: 'all 0.25s ease',
      }}
    >
      <Badge index={index} parentIndex={parentIndex} state={state} />

      {/* label + description */}
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ font: T.headline, fontWeight: 600, color: S.label }}>
          {label}
        </div>
        {desc && (
          <div style={{ font: T.caption, color: S.secondaryLabel, marginTop: 2 }}>
            {desc}
          </div>
        )}
      </div>

      {/* right-side indicator */}
      {isDone && (
        <div
          style={{
            font: T.tag, color: P.success, fontWeight: 700,
            background: 'rgba(45,138,78,0.10)',
            padding: '3px 8px', borderRadius: 999,
            flexShrink: 0,
          }}
        >
          принято
        </div>
      )}
      {isActive && (
        <div style={{ font: T.tag, color: P.terraDark, fontWeight: 700, flexShrink: 0 }}>
          сейчас →
        </div>
      )}
    </button>
  );
}
